export default "/staticreactui/static/media/static/media/adminSubmarine.e98945da.png";